export default __webpack_public_path__ + "static/media/bag6.1635d0e2.jfif";